import { ForgeProjectRole } from "./project-membership";
import { z } from "zod";
export const ForgeProjectInvitation = z.object({
    email: z.string().email(),
    forgeProjectId: z.string(),
    workspaceInvitationId: z.string(),
    role: ForgeProjectRole,
    effectiveRole: ForgeProjectRole,
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    createdById: z.string(),
});
